import { z } from "zod";
/**
 * Domain enumerations. These mirror the PostgreSQL enum types created in migration
 * `0001_core_tables.sql`; changing one without the other is a migration bug, and the
 * integration suite asserts the two lists agree.
 */
export const TENANT_STATUSES = ["active", "suspended", "trial", "archived"];
export const tenantStatusSchema = z.enum(TENANT_STATUSES);
/** Only an active tenant may authenticate (spec 001, stories 1 and 2). */
export function tenantCanAuthenticate(status) {
    return status === "active";
}
/**
 * Roles are a primitive in spec 001: the values exist and are stored, but nothing branches on
 * them yet beyond the branding endpoint. Spec 003 gives them behaviour.
 */
export const USER_ROLES = ["dueno", "contador", "operador"];
export const userRoleSchema = z.enum(USER_ROLES);
export const USER_STATUSES = ["active", "inactive"];
export const userStatusSchema = z.enum(USER_STATUSES);
export const ACTOR_TYPES = ["user", "system", "platform_owner"];
export const actorTypeSchema = z.enum(ACTOR_TYPES);
export const AUDIT_SEVERITIES = ["info", "important", "critical"];
export const auditSeveritySchema = z.enum(AUDIT_SEVERITIES);
export const FILE_CATEGORIES = [
    "source_file",
    "settlement_image",
    "export",
    "branding_logo",
    "backup",
];
export const fileCategorySchema = z.enum(FILE_CATEGORIES);
//# sourceMappingURL=enums.js.map